<header class="fixed-top shadow">
  <patient-ui-public-header></patient-ui-public-header>
</header>
<!-- mt-lg-9 tracks the header ABOVE this wrapper (PCSA-13563). `mt-8` (64px) is
     the clearance for this shell's own public header; on the one route that swaps
     in the taller portal header instead — Update Insurance, which the Billing
     Agent links a signed-in patient to — lg+ needs the portal shell's 96px, or the
     page opens 32px too high and its breadcrumb renders behind the header. Below
     lg the two headers are the same height, so `mt-8` stands there and guest pages
     keep it at every width. See `showPortalHeader$`.

     has-orbi-entry arms the page-level clearances for the fixed entry point
     (`orbi-rail-gutter` / `orbi-rail-offset` / `orbi-band-gap` /
     `orbi-band-head` / `orbi-band-row` / `orbi-band-title` / `orbi-band-lead` /
     `orbi-band-flush`, defined in styles.scss) and, below lg, the bottom pad that keeps a page's last control
     out from under the docked bar. Armed only while the agent is actually
     available — Split flag AND identity verified (PCSA-13452). -->
<section
  class="main-content-wrapper flex-fill mt-8"
  [class.mt-lg-9]="showPortalHeader$ | async"
  [class.has-orbi-entry]="orbiAgentAvailable$ | async"
>
  <router-outlet></router-outlet>
  <!-- Orbi AI entry point (PCSA-13157) on the PUBLIC shell too. Several pages the
       agent itself links a signed-in patient to are public-layout routes — Update
       Insurance from the Find a Bill card
       (`/invoices/insurance?navigatedFrom=RU`) above all — and until now the
       agent vanished the moment it sent the patient to one (design review 08/20).

       Nothing here needs a route ALLOWlist: the bar and the panel both gate on
       `selectOrbiAgentAvailable`, which requires a SIGNED-IN, identity-verified
       patient and so is false on every guest path this shell also serves
       (landing, registration, guest bill pay).

       That selector does carry a short route DENYlist, for the one case a state
       gate cannot describe: this shell also owns the login handoff screens
       (`/callback`, `/ui/transition`, …), where all three state gates are true —
       the token has been exchanged and the patient record has landed — while the
       patient has not actually arrived anywhere yet. QA caught the bar drawn over
       "Establishing Secure Connection" on 08/25. See `selectOrbiOnHandoffRoute`.

       The signed-in half of that gate was added after QA found the bar on the
       logged-out landing page (08/21). The identity check alone was not enough:
       it reads the `patient` slice, which no logout clears, and logout is a
       `router.navigate` rather than a page load — so the patient who just signed
       out was still 'passed' in the store while this guest shell rendered. See
       `selectOrbiSignedIn`.

       As in the portal shell it must stay AFTER `router-outlet` so that
       `router-outlet + *` (styles.scss) keeps selecting the routed page. -->
  <patient-ui-orbi-entry-button></patient-ui-orbi-entry-button>
</section>
<!-- The chat panel and its wiring, shared with PortalLayoutComponent. Outside the
     wrapper above: it is an off-canvas overlay, so it must not sit inside the
     flow it covers. -->
<patient-ui-orbi-agent-host></patient-ui-orbi-agent-host>
<footer class="bg-white text-light">
  <hr class="m-0" />
  <patient-ui-public-footer></patient-ui-public-footer>
</footer>
<!-- Idle-timeout modal. Armed for the RU flow as before, and now for ANY signed-in
     patient on this shell (QA 08/23): several of the pages the agent links to are
     public-layout routes, and on those the session was never watched, so nothing
     ever noticed it expiring — see `loggedIn$`. Guests render nothing here. -->
<patient-ui-portal-timout-modal
  *ngIf="navigatedFrom || (loggedIn$ | async)"
  (logoutDecision)="handleSession($event)"
></patient-ui-portal-timout-modal>

<ng-template #ieNotificationModalRef let-modal>
  <div class="modal-header">
    <h2 ngbAutofocus class="modal-title flex-fill text-center mt-6">
      <span class="alert-icon material-icons-round">warning</span> Browser Not Supported
    </h2>
  </div>
  <div class="modal-body">
    <div class="custom-modal-body">
      <p>
        Internet Explorer is no longer supported. You will be unable to access important features of the site on this browser. We recommend
        using the latest version of Google Chrome or Microsoft Edge.
      </p>

      <p>
        If you're unable to use a different browser, contact Customer Service at 1-800-845-6167, Monday through Friday between 8 am and 8 pm
        EST.
      </p>
    </div>
  </div>
</ng-template>
